import React, { useState, useEffect } from "react";
import SearchBar from "../components/SearchBar";
import apiClient from "../services/apiClient";
import { useTranslation } from 'react-i18next';

const StreakDashboard = () => {
  const [streak, setStreak] = useState(0);
  const [badges, setBadges] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    apiClient
      .get("/api/v1/progress/reading_streak")
      .then((data) => {
        setStreak(data.streak);
        setBadges(data.badges);
      })
      .catch((error) => console.error("Error fetching streak:", error));
  }, []);

  const Badges = ({ badges }) => (
    <div>
      <h2>{t('yourBadges')}</h2>
      <ul>
        {badges.map((badge) => (
          <li key={badge.id}>{badge.name}</li>
        ))}
      </ul>
    </div>
  );

  return (
    <div>
      <h2>{t('readingStreak')}</h2>
      <p>
        {t('streakOf')} <strong>{streak}</strong> {t('days')}!
      </p>
      {badges && badges.length > 0 && <Badges badges={badges} />}
    </div>
  );
};

const HomePage = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    apiClient.get("/api/v1/stories")
      .then((response) => {
        setStories(response.data);
        setLoading(false);
      })
      .catch((error) => console.error("Error fetching stories:", error));
  }, []);

  const handleSearchResults = (results) => {
    setStories(results);
  };

  if (loading) {
    return <p>{t('loading')}</p>;
  }

  return (
    <div className="container mx-auto p-4">
      <StreakDashboard />
      <h1 className="text-2xl font-bold mb-4">{t('storyList')}</h1>
      <SearchBar onSearch={handleSearchResults} />
      <div className="grid grid-cols-3 gap-4">
        {stories.map((story) => (
          <div key={story.id} className="relative p-4 border rounded shadow hover:shadow-lg transition">
            <a href={`/stories/${story.id}/chapters`} className="text-blue-500">
              <img
                src={story.cover}
                alt={story.name}
                className="w-full h-48 object-cover mb-2"
              />
              <h2 className="text-xl font-semibold">{story.name}</h2>
            </a>
            <div className="absolute top-2 left-2 bg-green-500 text-white text-xs px-2 py-1 rounded">
              Miễn Phí
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePage;